export default class Locale_ResourceSpecificWorkprofileEditor { 
	WorkProfile: string = "Workprofile"
	EditResourceSpecificWorkProfile: string = "Edit resource specific work profile";
}